import RiceBowlIcon from "@mui/icons-material/RiceBowl";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import HouseIcon from "@mui/icons-material/House";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import KitchenIcon from "@mui/icons-material/Kitchen";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";
import SportsEsportsIcon from "@mui/icons-material/SportsEsports";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import CasesIcon from "@mui/icons-material/Cases";
import MoneyIcon from "@mui/icons-material/Money";
import FlagIcon from "@mui/icons-material/Flag";
import { IncomeCategory, ExpenseCategory, Category } from "../../types";

const IconComponents: Record<string, React.ReactElement> = {
  食費: <RiceBowlIcon fontSize="small" />,
  RiceBowlIcon: <RiceBowlIcon fontSize="small" />,
  日用品: <ContentCutIcon fontSize="small" />,
  ContentCutIcon: <ContentCutIcon fontSize="small" />,
  光熱費: <ElectricBoltIcon fontSize="small" />,
  ElectricBoltIcon: <ElectricBoltIcon fontSize="small" />,
  居住費: <HouseIcon fontSize="small" />,
  HouseIcon: <HouseIcon fontSize="small" />,
  医療費: <MedicalServicesIcon fontSize="small" />,
  MedicalServicesIcon: <MedicalServicesIcon fontSize="small" />,
  娯楽費: <SportsEsportsIcon fontSize="small" />,
  SportsEsportsIcon: <SportsEsportsIcon fontSize="small" />,
  家電: <KitchenIcon fontSize="small" />,
  KitchenIcon: <KitchenIcon fontSize="small" />,
  その他: <FlagIcon fontSize="small" />,
  FlagIcon: <FlagIcon fontSize="small" />,
  給与: <AssuredWorkloadIcon fontSize="small" />,
  AssuredWorkloadIcon: <AssuredWorkloadIcon fontSize="small" />,
  副収入: <AddBusinessIcon fontSize="small" />,
  AddBusinessIcon: <AddBusinessIcon fontSize="small" />,
  事業: <BusinessCenterIcon fontSize="small" />,
  BusinessCenterIcon: <BusinessCenterIcon fontSize="small" />,
  ボーナス: <CasesIcon fontSize="small" />,
  CasesIcon: <CasesIcon fontSize="small" />,
  一時収入: <MoneyIcon fontSize="small" />,
  MoneyIcon: <MoneyIcon fontSize="small" />,
  バイト: <MoneyIcon fontSize="small" />,
};

export const categoryDefaultIcon = <FlagIcon fontSize="small" />;

// 以下を利用することも可能として用意するのみ。
export const _categoryIcon = [
  { type: "income", label: "給与", icon: <span>💰</span> },
  { type: "income", label: "副収入", icon: <span>💼</span> },
  { type: "income", label: "事業", icon: <span>📊</span> },
  { type: "income", label: "ボーナス", icon: <span>🎁</span> },
  { type: "income", label: "一時収入", icon: <span>💸</span> },
  { type: "income", label: "バイト", icon: <span>💸</span> },
  { type: "expense", label: "食費", icon: <span>🍽️</span> },
  { type: "expense", label: "日用品", icon: <span>🧻</span> },
  { type: "expense", label: "光熱費", icon: <span>💡</span> },
  { type: "expense", label: "居住費", icon: <span>🏠</span> },
  { type: "expense", label: "医療費", icon: <span>🏥</span> },
  { type: "expense", label: "娯楽費", icon: <span>🎬</span> },
  { type: "expense", label: "家電", icon: <span>📺</span> },
  { type: "expense", label: "その他", icon: <span>📦</span> },
];

export const defaultCategory: Category = {
  userId: "guest",
  expense: [
    {
      isDefault: true,
      label: "食費",
      otherLangs: [
        { lang: "ja", label: "食費" },
        { lang: "ko", label: "식비" },
        { lang: "en", label: "Food & Dining" },
      ],
      icon: "RiceBowlIcon",
    },
    {
      isDefault: true,
      label: "日用品",
      otherLangs: [
        { lang: "ja", label: "日用品" },
        { lang: "ko", label: "생활용품" },
        { lang: "en", label: "Daily Supplies" },
      ],
      icon: "ContentCutIcon",
    },
    {
      isDefault: true,
      label: "光熱費",
      otherLangs: [
        { lang: "ja", label: "光熱費" },
        { lang: "ko", label: "공과금" },
        { lang: "en", label: "Utilities" },
      ],
      icon: "ElectricBoltIcon",
    },
    {
      isDefault: true,
      label: "居住費",
      otherLangs: [
        { lang: "ja", label: "居住費" },
        { lang: "ko", label: "주거비" },
        { lang: "en", label: "Housing & Rent" },
      ],
      icon: "HouseIcon",
    },
    {
      isDefault: true,
      label: "医療費",
      otherLangs: [
        { lang: "ja", label: "医療費" },
        { lang: "ko", label: "의료비" },
        { lang: "en", label: "Medical & Healthcare" },
      ],
      icon: "MedicalServicesIcon",
    },
    {
      isDefault: true,
      label: "娯楽費",
      otherLangs: [
        { lang: "ja", label: "娯楽費" },
        { lang: "ko", label: "문화/유흥비" },
        { lang: "en", label: "Entertainment" },
      ],
      icon: "SportsEsportsIcon",
    },
    {
      isDefault: true,
      label: "家電",
      otherLangs: [
        { lang: "ja", label: "家電" },
        { lang: "ko", label: "가전제품" },
        { lang: "en", label: "Electronics" },
      ],
    },
    {
      isDefault: true,
      label: "その他",
      otherLangs: [
        { lang: "ja", label: "その他" },
        { lang: "ko", label: "기타" },
        { lang: "en", label: "Other" },
      ],
      icon: "FlagIcon",
    },
  ],
  income: [
    {
      isDefault: true,
      label: "給与",
      otherLangs: [
        { lang: "ja", label: "給与" },
        { lang: "ko", label: "급여" },
        { lang: "en", label: "Salary" },
      ],
      icon: "AssuredWorkloadIcon",
    },
    {
      isDefault: true,
      label: "副収入",
      otherLangs: [
        { lang: "ja", label: "副収入" },
        { lang: "ko", label: "부수입" },
        { lang: "en", label: "Side Income" },
      ],
      icon: "AddBusinessIcon",
    },
    {
      isDefault: true,
      label: "事業",
      otherLangs: [
        { lang: "ja", label: "事業" },
        { lang: "ko", label: "사업소득" },
        { lang: "en", label: "Business" },
      ],
      icon: "BusinessCenterIcon",
    },
    {
      isDefault: true,
      label: "ボーナス",
      otherLangs: [
        { lang: "ja", label: "ボーナス" },
        { lang: "ko", label: "보너스" },
        { lang: "en", label: "Bonus" },
      ],
      icon: "CasesIcon",
    },
    {
      isDefault: true,
      label: "一時収入",
      otherLangs: [
        { lang: "ja", label: "一時収入" },
        { lang: "ko", label: "임시수입" },
        { lang: "en", label: "Extraordinary Income" },
      ],
      icon: "MoneyIcon",
    },
    {
      isDefault: true,
      label: "バイト",
      otherLangs: [
        { lang: "ja", label: "バイト" },
        { lang: "ko", label: "아르바이트" },
        { lang: "en", label: "Part-time Job" },
      ],
      icon: "MoneyIcon",
    },
  ],
};

// カテゴリ用アイコンレンダリング、Muiアイコンまたは絵文字
export const renderCategoryIcon = (
  label: string,
  iconKey?: string,
): React.ReactElement => {
  // 1. icon フィールドが絵文字の場合（例："🍽️")
  if (iconKey && !IconComponents[iconKey]) {
    return <span>{iconKey}</span>;
  }
  // 2. IconComponentsで用意がある場合
  if (iconKey && IconComponents[iconKey]) {
    return IconComponents[iconKey];
  }
  if (IconComponents[label]) {
    return IconComponents[label];
  }
  // 3. Defaultアイコン
  return categoryDefaultIcon;
};

export default IconComponents;
